module.exports = __webpack_public_path__ + "img/after-3.02ad646d.png";